import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const GetInvoiceStatus = createAsyncThunk(
  "dashboard/invoice",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Dashboard}/invoice-status?page=${filter?.page ||
          IDS.PAGE}&per_page=${5 || filter?.perPage || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetMonthlyTransaction = createAsyncThunk(
  "dashboard/monthly-tranzaction",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Dashboard}/monthly-transaction`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetEquipmentStatus = createAsyncThunk(
  "dashboard/equipment-status",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Dashboard}/equipment-status`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSamplePerform = createAsyncThunk(
  "dashboard/sample-perform",
  async ({ year="" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Dashboard}/sample-perform?year=${year}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetNotification = createAsyncThunk(
  "dashboard/notification",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Dashboard}/notification?page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const Slice = createSlice({
  name: "bashboard",
  initialState: {
    data: [],
    monthly_transaction: [],
    equipment_status: [],

    sample_perform: [],
    notifications: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetInvoiceStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetInvoiceStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.data = action.payload?.data || {};
      })
      .addCase(GetInvoiceStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetMonthlyTransaction.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetMonthlyTransaction.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.monthly_transaction = action.payload?.data || {};
      })
      .addCase(GetMonthlyTransaction.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetEquipmentStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetEquipmentStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.equipment_status = action.payload?.data || {};
      })
      .addCase(GetEquipmentStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetSamplePerform.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSamplePerform.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.sample_perform = action.payload?.data || {};
      })
      .addCase(GetSamplePerform.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetNotification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetNotification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.notifications = action.payload?.data || [];
      })
      .addCase(GetNotification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
